export default {
  views: {
    product: {
      description:
        'An affordable ticket that combines admission to the Tokyo Skytree observation deck and Sumida Aquarium.',
      plans: {
        title: 'Select Plan'
      },
      cancelPolicy: {
        title: 'Cancel Policy'
      },
      panels: {
        selectDate: 'Select Date',
        selectPlan: 'Select Plan',
        selectPeople: 'Select Number of People',
        options: 'Options',
        profile: 'Profile'
      },
      auth: {
        loginOrRegister: 'Login / Register',
        signUpTip: 'Please input your information to register'
      },
      calendar: {
        priceNote: '※Displayed price is adult admission for the day'
      },
      recommendations: {
        title: 'Recommended Products'
      }
    },
    book: {
      title: 'Book Confirm',
      bookingNotice: 'Please check before booking',
      paymentConfirmation: 'Please check before payment',
      tip: 'Please complete the operation as soon as possible to confirm your order.'
    },
    bookConfirm: {
      paymentInfo: 'Payment Information',
      paymentConfirmation: {
        warningTitle: 'Please confirm the cancellation policy:',
        warningText: 'Once purchased, this product cannot be refunded.',
        agreementText: 'I have read and agree to the Terms and Conditions.'
      },
      prePaymentConfirmation: {
        title: 'Pre-payment Confirmation',
        checkInput: 'Please confirm that the entered information is correct.',
        emailNotice:
          'Note: If you have domain-specific email filtering enabled, please register "@linktivity.co.jp" before making a reservation.',
        agreementText: 'I have reviewed and agree to the above.'
      },
      paymentAmount: {
        total: 'Payment Amount (Including Tax)',
        details: 'Details',
        note: 'For non-JPY currencies, the displayed amount is an estimate based on the current exchange rate and may differ slightly from the actual charge. For reference only.'
      },
      participantInfo: {
        title: 'Representative Information',
        dialogTitle: 'Edit Representative Information',
        change: 'Change',
        password: 'Password',
        validation: {
          passwordRequired: 'Please enter your password'
        }
      },
      actionButtons: {
        back: 'Back',
        toPayment: 'To Payment'
      }
    },
    voucher: {
      pdf: 'Printable PDF',
      html: 'View Voucher'
    },
    bookingDetail: {
      title: 'Booking Details',
      detailInfo: 'Booking Details',
      startDate: 'Start Date',
      validityPeriod: 'Validity Period',
      voucherInfo: 'Voucher Information',
      digitalTicket: 'Digital Ticket',
      invoice: 'Receipt / Invoice',
      invoiceSend: 'Issue',
      invoiceSent: 'Invoice Issued',
      redemption: 'Use E-ticket',
      meetingPoint: 'Entry Location Guide',
      beforeTrip: 'Pre-use Checklist',
      bookingAction: 'Booking Actions',
      cancelBooking: 'Cancel Booking',
      cancelConfirmPolicy: 'Please confirm the cancellation policy:',
      customerName: 'Reservation Name',
      actualPayment: 'Payment Amount',
      refundAmount: 'Refund Amount',
      orderId: 'Booking ID',
      orderCompletionTime: 'Booking Time',
      digitalTicketValidPeriod: 'QR code is valid only on the day of use',
      digitalTicketWaiting:
        '*Digital ticket will be displayed here after order confirmation',
      sending: 'Sending...',
      sendToEmail: 'Send to Email',
      cancelConfirm: 'Are you sure you want to cancel the booking?',
      cancelFee: 'Cancellation Fee',
      cancelRemarkSelect: 'Please select a cancellation reason',
      inclusion: 'Included items',
      checklist: 'Checklist',
      restrictions: 'Restrictions',
      requirements: 'Requirements before and during participation',
      attireItems: 'Clothing and belongings required for participation',
      otherInfo: 'Other',
      attachmentType: {
        ATTACHMENT_TYPE_PDF: 'PDF',
        ATTACHMENT_TYPE_IMAGE: 'Image'
      }
    },
    cancelReason: {
      CANCEL_REASON_OTHER: 'Other',
      CANCEL_REASON_MODIFY_BOOKING: 'Modify booking',
      CANCEL_REASON_BOOKED_BY_MISTAKE: 'Booked by mistake',
      CANCEL_REASON_DUPLICATE_BOOKING: 'Duplicate booking',
      CANCEL_REASON_HEALTH_CONDITION: 'Illness',
      CANCEL_REASON_TRANSPORTATION_ISSUE: 'Transportation issue',
      CANCEL_REASON_SCHEDULE_CONFLICT: 'Schedule conflict',
      CANCEL_REASON_CHANGE_TO_OTHER_PRODUCT: 'Change to other product'
    },
    common: {
      withDashSeparated: '{{val1}} - {{val2}}'
    },
    components: {
      selectOption: {
        title: 'Option',
        quantity: 'Quantity: {{quantity}}',
        addCart: 'Add to Cart',
        timeSelect: 'Select a time',
        quantitySelect: 'Select a quantity',
        quantitySelectLabel: 'Quantity',
        soldOut: 'Sold Out',
        total: 'Total'
      },
      planCard: {
        tip: 'Same-day ticket will be sold'
      },
      planDetailDialog: {
        title: 'Plan Details',
        planContent: 'Plan Content',
        meetingPlace: 'Meeting Place',
        cancellationPolicy: 'Cancellation Policy'
      },
      priceTableDialog: {
        notes: {
          agePolicy: `Children aged 5 and under are free; 6-year-olds not yet in elementary school are also free. A child rate applies to 15-year-olds in junior high school, while a full adult rate applies to high-school students.`
        }
      },
      payment: {
        ticket: 'Ticket',
        option: 'Option',
        total: 'Total (Including Tax)',
        details: 'Details',
        submit: 'Proceed to Order'
      },
      bookingInfo: {
        plan: 'Plan',
        dateTime: 'Date & Time',
        ticket: 'Ticket',
        option: 'Option',
        discount: 'Discount',
        total: 'Payment Amount (Including Tax)'
      }
    },
    home: {
      title: 'Tokyo Skytree',
      header: {
        alt: 'Tokyo Skytree'
      },
      search: {
        placeholder: 'Search products'
      },
      ticketList: {
        title: 'Ticket List'
      },
      enjoyPack: {
        title: 'Enjoy Pack'
      }
    },
    faq: {
      title: 'FAQ',
      purchase: {
        title: 'Ticket Purchase',
        q1: 'I’m unable to make a payment with my credit card.',
        a1: `If you are unable to proceed to the final step of the payment screen, please check the following:

1）Network Connection
・Your payment may have been interrupted due to a temporary network issue.
Please close the screen, wait a moment, and try again from the beginning in an area with a stable connection.

2）Card Status and 3D Secure
・Please confirm that your credit card’s expiration date and available credit limit are valid.
・Please confirm that your credit card supports “3D Secure.”
From April 2025, the implementation of “3D Secure” has become mandatory for online purchases.
Accordingly, on the Tokyo Skytree reservation website, payment can only be made with cards that have “3D Secure” enabled.

3）Card Issuer Security System
If your card appears to have no issues but the payment still cannot be processed, the transaction may have been interrupted by your card issuer’s security system.
In this case, please contact your card issuer directly.

・If you would like a detailed confirmation of your payment status, please contact us using the inquiry form below.
https://veltra.zendesk.com/hc/en-gb/requests/new?ticket_form_id=53455569113241`,
        q2: 'My preferred date and time shows an “X” on the calendar.',
        a2: `＜Tokyo Skytree Observation Deck・Tembo Galleria Admission Ticket＞
・Admission tickets go on sale 2 months in advance, and the calendar opens sequentially.
・If, after sales begin, your preferred date or time slot cannot be clicked on the purchase page calendar, the tickets are sold out.
If there is no availability for your preferred date or time, please consider alternative dates and times.
▼Sales page
https://global-official-ticket.tokyo-skytree.jp/en/home

※Online purchase is available until the day of your visit, however tickets may sell out early during peak seasons such as long holiday periods.
※Online tickets are offered at a more favorable price than same-day counter sales, so advance purchase is recommended.

＜Skytree Enjoy Pack＞
・The Enjoy Pack goes on sale one month in advance, and can be purchased until the day before your intended visit（same-day sales are not available）`,
        q3: 'When do ticket sales begin?',
        a3: `＜Tokyo Skytree Observation Deck・Tembo Galleria Admission Ticket＞
・Admission tickets go on sale 2 months in advance, and the calendar opens sequentially.
・Online purchase is available until the day of your visit, however tickets may sell out early during peak seasons such as long holiday periods.

＜Skytree Enjoy Pack＞
・The Enjoy Pack goes on sale one month in advance. It can be purchased until the day before your intended visit（same-day sales are not available）

※Tickets for special business hours, such as the Sumida River Fireworks Festival or New Year’s Day, have different sales start dates. Details will be announced on the official Tokyo Skytree website as the date approaches.`,
        q4: 'What payment methods are available for online purchases?',
        a4: `Credit cards(VISA, MASTER, AMEX,JCB,DINERS), debit cards, Alipay, and Wechatpay are accepted.`,
        q5: 'Are same-day tickets available? Can I definitely purchase them on-site?',
        a5: `＜Tokyo Skytree Observation Deck・Tembo Galleria Admission Ticket＞
・There is no separate allocation reserved for same day tickets. All tickets are offered as advance sales and may be purchased on the day only for dates and times where inventory remains available in advance. Tickets that are already sold out will not be released for additional sale on the day.
・Tickets can be purchased through online sales or on site ticket machines only if inventory is available on the day. Tickets that were sold out in advance will not be made available for additional sale on the day.
・During peak seasons such as long holiday periods tickets may sell out early.
・Tickets purchased online are offered at a more favorable price than same day counter sales therefore advance purchase is recommended.
・Please check the latest availability on the sales page below.

▼Sales page
https://global-official-ticket.tokyo-skytree.jp/en/home

＜Skytree Enjoy Pack＞
・The Enjoy Pack is not available for same-day purchase. Please purchase it by the day before your intended visit.`,
        q6: 'Which ticket should be purchased for a student who has graduated from junior high school but has not yet entered high school?',
        a6: `As of the date of admission, guests aged 15 and under are charged the child rate, and guests aged 16 and over are charged the adult rate.`,
        q7: 'Is membership registration required?',
        a7: `Membership registration is required to purchase Tokyo Skytree tickets.
If you are unable to log in, please refer to the page below.

▼ If you are unable to log in
Please refer to the FAQ section titled “I cannot log in.” for further instructions.`,
        q8: 'Does the disability discount apply to the Enjoy Pack?',
        a8: `The Enjoy Pack is already offered at a discounted special price, therefore additional disability discounts do not apply.`,
        q9: 'Is shopping or dining available inside Tokyo Skytree and is parking available?',
        a9: `For details regarding facilities, parking, group reservations, and parking for groups, please check the “FAQ” section on the “Contact” page of the official Tokyo Skytree website.
▼Official Tokyo Skytree website for questions regarding facilities
https://www.tokyo-skytree.jp/en/faq/

▼Official Tokyo Skytree website For group reservations
https://www.tokyo-skytree.jp/ticket/group/general/`
      },
      late: {
        title: 'If You Expect to Be Late for Your Entry Time',
        q1: 'I may be late for my reservation time. Can I still enter?',
        a1: `As a general rule, please arrive during the time slot specified at the time of purchase.

However, if you are running late due to unforeseen circumstances, guests with Date/Time Designated Tickets may still enter later on the scheduled day by joining the end of the current entry line.

Please note that guests will be admitted in the order of arrival, and there may be a wait depending on how crowded it is.
For today’s operating hours, please check the official Tokyo Skytree website.

▼Operating Hours Calendar
https://www.tokyo-skytree.jp/open-hours/`
      },
      conditions: {
        title: 'View and Crowd Conditions',
        q1: 'What if the weather is bad on the day of my visit?',
        a1: `Visibility varies depending on the time of day, and the we cannot provide information about the view in advance. Please refer to local Tokyo weather information.
Refunds or partial discounts are not available due to poor visibility caused by rain or cloudy weather.
If you wish to cancel your reservation, please review the cancellation policy and any applicable cancellation fees on My Page before proceeding.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking`,
        q2: 'How crowded will it be on the day of my visit?',
        a2: `Congestion forecasts are available on the top page of the official Tokyo Skytree website.
・Elevator waiting times may occur depending on congestion. Please note that the call center cannot provide real-time waiting time information. We recommend allowing extra time for your visit.
・There is no time limit after entering the observation deck. However, in rare cases, staff may provide guidance due to congestion or elevator operation conditions.

▼Official Tokyo Skytree website Congestion Forecast
https://www.tokyo-skytree.jp/en//ticket/congestion/`
      },
      email: {
        title: 'If You Have Not Received the Booking Confirmation Email',
        q1: 'I did not receive my reservation confirmation email.',
        a1: `A confirmation email with the subject line “Your booking has been confirmed (Booking ID: ARS_SKYTREE-XXXX-XXXX)” is automatically sent to the email address registered at the time of booking.
・The confirmation email is sent from the "@linktivity.co.jp" domain.
・Please check your spam or junk mail folder.
・You may have registered with an email address that you do not regularly use. Please check any other possible email accounts.

If you cannot find the email, please log in to My Page to confirm your reservation details.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

＊If you purchased tickets through an online travel agency other than the official Tokyo Skytree website, please contact the agency directly.`
      },
      use: {
        title: 'How to Use and Display Your Ticket',
        q1: 'I completed payment, but I cannot find my ticket.',
        a1: `The voucher containing the QR code for the ticket required on the day of your visit can be found on My Page or in your reservation confirmation email.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

▼About the reservation confirmation email
・The confirmation email is sent from the "@linktivity.co.jp" domain.
・Please check your spam or junk mail folder.
・You may have registered with an email address that you do not regularly use. Please check any other possible email accounts.

▼ If you are unable to log in
Please refer to the FAQ section titled “I cannot log in.” for further instructions.

＊If you purchased tickets through an online travel agency other than the official Tokyo Skytree website, please contact the agency directly.
*QR Code is a registered trademark of DENSO WAVE INCORPORATED.`,
        q2: 'The QR code does not appear on my smartphone screen. *QR Code is a registered trademark of DENSO WAVE INCORPORATED.',
        a2: `The voucher containing the QR code for the ticket required on the day of your visit can be accessed via My Page or your reservation confirmation email.

If the QR code does not display properly on your mobile device, please close the screen once and try again in an area with a stable internet connection.
A QR code is required for entry. Please confirm in advance that it can be displayed on your device. Taking a screenshot in advance is also recommended.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

▼ If you are unable to log in
Please refer to the FAQ section titled “I cannot log in.” for further instructions.

＊If you purchased through an online travel agency other than the official Tokyo Skytree website, please contact the travel agency where you made your purchase.
*QR Code is a registered trademark of DENSO WAVE INCORPORATED.`,
        q3: 'I cannot log in.',
        a3: `First, please confirm that you are using the correct email address.
You may have registered with an email address that you do not use regularly. Please try logging in with any other possible email addresses.

Please use the same login method that you selected when registering.
If you use Gmail, please confirm whether you registered by selecting the “Google” button for Google account linkage, or by selecting the “E-mail” button and entering your email address directly.
If you forgot your password, please select “Forgot your password?” on the login screen to reset it.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

＊If you purchased through an online travel agency other than the official Tokyo Skytree website, please contact the travel agency where you made your purchase.`,
        q4: 'I accidentally deleted my reervation confirmation email. What should I do?',
        a4: `You can display your voucher and QR code using one of the following methods:

Check your reservation on My Page
Log in to My Page → Click the person icon in the upper right corner → “My Page” → “Reservation Information” → View reservation list → Open the reservation details screen to display the voucher

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

Resend the voucher email from My Page
Log in to My Page → Click the person icon in the upper right corner → “My Page” → “Reservation Information” → View reservation list → On the reservation details screen, click the “Send Voucher” button to resend the voucher containing the ticket URL to any email address

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

＊If you purchased through an online travel agency other than the official Tokyo Skytree website, please contact the travel agency where you made your purchase.
*QR Code is a registered trademark of DENSO WAVE INCORPORATED.`,
        q5: 'I deleted my account and cannot log in to My Page. Can I still use my ticket?',
        a5: `As long as you have not canceled your reservation, your ticket remains valid and can be used.
You can access the voucher containing the QR code from your reservation confirmation email.

*QR Code is a registered trademark of DENSO WAVE INCORPORATED.`,
        q6: 'Can I print the voucher and bring it with me?',
        a6: `You may use a printed copy of the QR code. Screenshots or display on a mobile device are also accepted.
If printing, please ensure that the QR code is clearly printed.
*QR Code is a registered trademark of DENSO WAVE INCORPORATED.`,
        q7: 'Is there a time limit after entering the observation deck?',
        a7: `There is no time limit after entering the observation deck.`,
        q8: 'Can I receive my ticket in advance at the facility?',
        a8: `From March 2, 2026, following the ticket system renewal, on-site ticket issuance procedures are no longer required.
On the day of your visit, simply click the link in your voucher and present the QR code displayed on your screen at the entrance for direct admission.
*QR Code is a registered trademark of DENSO WAVE INCORPORATED.`,
        q9: 'If I arrive early, can I enter before my reserved time?',
        a9: `Entry before your reserved time is not permitted.
Please enter during the time slot selected at the time of purchase.`,
        q10: 'Can I re-enter after exiting?',
        a10: `Re-entry is not permitted once you exit the observation deck.`
      },
      changes: {
        title: 'Changes and Cancellations',
        q1: 'Can I change the admission date, time, or number of guests?',
        a1: `We sincerely apologize, but changes to the selected admission date, admission time, or number of guests are not permitted.
If you wish to make changes, please cancel your current reservation and make a new purchase with your preferred details.

・If you are likely to be late for your reservation time, you may enter later only on the designated date from the end of the admission queue. Please note that guests will be admitted in the order of arrival, and there may be a wait depending on how crowded it is.
・If you cancel, a cancellation fee will apply in accordance with the cancellation policy. Please review the cancellation policy and applicable fees on My Page before completing the procedure.
・To prevent errors, cancellations cannot be accepted by phone or email. Thank you for your understanding.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

*If you purchased your ticket through an online travel agency other than the official Tokyo Skytree website, the cancellation policy may differ from that of the official website.
We kindly recommend checking the cancellation terms provided at the time of booking through your original purchase platform and reach out to the travel agency's customer support team.`,
        q2: 'Can I upgrade from an Observation Deck ticket to a combined ticket with the Tembo Galleria?',
        a2: `・We apologize, but changes to a Tembo Galleria set ticket cannot be made after purchase.
・Tembo Galleria admission tickets can be purchased on the day at the ticket counter located on the 350m Tembo Deck. However, sales may be suspended depending on congestion at the Tembo Galleria. Thank you for your understanding.`,
        q3: 'Can I cancel my ticket?',
        a3: `・Cancellation policies vary depending on the ticket type. If you wish to cancel, please review the cancellation policy and applicable cancellation fees on My Page before proceeding.
・A cancellation fee will apply in accordance with the cancellation policy.
・To prevent errors, cancellations cannot be accepted by phone or email. Thank you for your understanding.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

*If you purchased your ticket through an online travel agency other than the official Tokyo Skytree website, the cancellation policy may differ from that of the official website.
We kindly recommend checking the cancellation terms provided at the time of booking through your original purchase platform and reach out to the travel agency's customer support team.`,
        q4: 'I did not use one of the facilities included in the Enjoy Pack. Can I receive a refund?',
        a4: `Refunds are not available if one of the included facilities is not used due to personal reasons.`,
        q5: 'I purchased the wrong ticket type, date, time, or number of guests.',
        a5: `・We apologize, but changes cannot be made if the ticket type, date, time, or number of guests was selected incorrectly.
If you wish to correct your reservation, please cancel your current booking and make a new purchase with the correct details.
・Please review the cancellation policy and applicable cancellation fees on My Page before proceeding.
・A cancellation fee will apply in accordance with the cancellation policy.
・To prevent errors, cancellations cannot be accepted by phone or email. Thank you for your understanding.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

*If you purchased your ticket through an online travel agency other than the official Tokyo Skytree website, the cancellation policy may differ from that of the official website.
We kindly recommend checking the cancellation terms provided at the time of booking through your original purchase platform and reach out to the travel agency's customer support team.`,
        q6: 'Can I cancel if it becomes difficult to visit due to natural disasters, transportation suspensions, or infectious diseases?',
        a6: `・Except in the case of temporary closure, special cancellations are not accepted.
In the event of temporary closure, information will be posted on the official Tokyo Skytree website.
・If you wish to cancel due to transportation suspensions, please review the cancellation policy and applicable cancellation fees on My Page and complete the procedure yourself.
・To prevent errors, cancellations cannot be accepted during the phone call. Thank you for your understanding.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking


▼Official Tokyo Skytree website
https://www.tokyo-skytree.jp/en/

*If you purchased your ticket through an online travel agency other than the official Tokyo Skytree website, the cancellation policy may differ from that of the official website.
We kindly recommend checking the cancellation terms provided at the time of booking through your original purchase platform and reach out to the travel agency's customer support team.`,
        q7: 'What happens if elevator operations are suspended due to strong winds?',
        a7: `・For the safety of our guests, elevator service to the observation deck may be temporarily suspended due to deteriorating weather conditions or strong winds at high altitude.
Please check the latest information on the official Tokyo Skytree website.
For details regarding the expected resumption of operations or refunds, please consult on-site staff first.

▼Official Tokyo Skytree website
https://www.tokyo-skytree.jp/en/`
      },
      payment: {
        title: 'Payment and Available Discounts',
        q1: 'It appears that I have been charged twice on my card.',
        a1: `・First, please check your reservation status on My Page.
If only one reservation is displayed, the other charge may be a pending authorization notification only, and the actual charge may not be completed.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

・If you would like a detailed confirmation of your payment status, please contact us via the form below. (Form URL)`,
        q2: 'My payment was displayed as failed. What should I do?',
        a2: `・First, please check on My Page whether your reservation has been completed.
If no reservation information is displayed, your booking has not been completed.
Please review the following and try the purchase process again.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

Common causes:

1）Network connection
・The transaction may have been interrupted due to temporary network instability or high booking traffic at the same time.
Please close the screen, wait a few moments, and try completing the payment again from the beginning in an area with a stable internet connection.

2）Card usage status / 3D Secure authentication
・Please check that the expiry date of your credit card and your credit limit.
・Please confirm that your credit card supports “3D Secure.”
From April 2025, implementation of “3D Secure” has become mandatory for online purchases.
On the Tokyo Skytree reservation site, payment is only possible with cards that have 3D Secure enabled.

3）Card issuer security system
If payment cannot be completed even though there is no issue with your card, your card issuer’s security system may have blocked the transaction.
Please try again later using a different card or contact your card issuer for assistance.

・If you would like a detailed confirmation of your payment status, please contact us via the form below.
https://veltra.zendesk.com/hc/en-gb/requests/new?ticket_form_id=53455569113241`,
        q3: 'I received a usage notification from my card company, but there is no reservation shown on My Page and I did not receive a confirmation email.',
        a3: `One of the following situations may apply:

1)You might have registered using an email address that you do not use regularly.
Please check the inbox and spam folder of any other possible email addresses.
Please also try logging in to My Page.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

2)You might have used Gmail and logged in using a different method
Please log in using the same method selected at the time of reservation (new registration).
・If you selected “Email login” when booking, please use “Email login.”
・If you selected “Google login” when booking, please use “Google login.”

3) The payment and reservation were not fully completed
Although the process may have progressed to the stage of securing your card limit, the payment and reservation may not have been completed due to temporary network instability.
Please check whether the charge appears on your card statement.

If you would like a detailed confirmation of your payment and reservation status, please contact us via the form below.
https://veltra.zendesk.com/hc/en-gb/requests/new?ticket_form_id=53455569113241`,
        q4: 'I canceled my reservation. When will I receive my refund?',
        a4: `・Cancellation fees vary depending on the ticket type. Please first confirm the applicable cancellation fee on My Page.
・If you believe you should have received a refund but have not, the refund process at your card issuer may still be in progress.
Please contact your card issuer directly to confirm.

・If you would like a detailed confirmation of your refund status, please contact us via the form below.
https://veltra.zendesk.com/hc/en-gb/requests/new?ticket_form_id=53455569113241`,
        q5: 'Can I receive a receipt?',
        a5: `・If you purchased through the official Tokyo Skytree website:
You can issue your receipt yourself via the “Receipt” button on My Page or in your reservation confirmation email.
After issuance, it will be sent from the domain “linktivity.co.jp” with the subject line “Receipt for your booking[Linktivity]”
Please also check your spam or junk mail folder.

▼My Page login
https://global-official-ticket.tokyo-skytree.jp/en/booking

・For group reservations:
Please refer to the dedicated page below.
▼Official Tokyo Skytree website for group reservations
https://www.tokyo-skytree.jp/ticket/group/general/

・If you purchased tickets on-site on the day of your visit:
Online issuance is not available. Please contact below.
▼Official Tokyo Skytree website
https://www.tokyo-skytree.jp/en/`
      },
      disabilities: {
        title: 'About Disability Pricing',
        q1: 'About Disability Pricing',
        a1: `Eligibility Conditions

Disability pricing is available for guests holding a disability certificate and their accompanying companions.
Companions may purchase tickets up to the same number as the certificate holder.
Your disability certificate will be checked upon entry, so please have it ready to present on the day of your visit.


Changing from Regular to Disability Pricing
If you have purchased tickets at the regular price, it is not possible to change them to disability pricing.
If you wish to make a change, please cancel your current reservation and make a new purchase with your desired details.
▼Log in to My Page here
https://global-official-ticket.tokyo-skytree.jp/en/booking`
      },
      group: {
        title: 'Group Reservations',
        q1: 'Group Reservations',
        a1: `Group reservations are handled by the dedicated Tokyo Skytree service desk.
Please refer to 'Inquiries regarding group reservations' at the Tokyo Skytree official website.
▼Tokyo Skytree Official Website Dedicated Group Reservations Desk
https://www.tokyo-skytree.jp/inquiry/
`
      },
      tips: `Email inquiries: <a href="mailto:helpcenter@linktivity.co.jp" rel="noreferrer">helpcenter@linktivity.co.jp</a>
Phone Inquiries for Online Purchases: <a href="tel:+81368217196">+81-3-6821-7196</a>

When you place a call, an automated voice system will first guide you through the available options. Depending on the matter you wish to address, you will be connected with a live agent.
Call charges will vary based on your phone carrier.
Operator hours: 10:00–19:00`
    }
  }
};
